import { useAuth } from "@workos-inc/authkit-react";
import { beginWorkOsSignIn } from "../lib/workos-sign-in";

function appOrigin(): string | undefined {
  return typeof window === "undefined" ? undefined : `${window.location.origin}/`;
}

export function WorkOsUserControls() {
  const { user, signIn, signOut, isLoading } = useAuth();

  if (isLoading) return <span className="muted">…</span>;
  if (user) {
    return (
      <button
        type="button"
        className="btn ghost"
        onClick={() => void signOut({ returnTo: appOrigin() })}
      >
        Sign out
      </button>
    );
  }
  return (
    <button type="button" className="btn primary" onClick={() => beginWorkOsSignIn(signIn)}>
      Sign in
    </button>
  );
}
